export default function PublicShareHeader() {
  return (
    <header className="public-share-header">
      <a href="/" className="brand-logo small" aria-label="Dined">
        <img src="/dined-mark.svg" alt="" />
        <span>Dined</span>
      </a>
    </header>
  );
}
